module.exports = __webpack_public_path__ + "static/media/bar_chart.6f20a728.svg";